import { Button, EmptyState, Icon } from '@beacon/ui/components';

export interface ErrorScreenProps {
  code?: string;
  title?: string;
  description?: string;
  onRetry?: () => void;
  onReload?: () => void;
  onHome?: () => void;
  homeLabel?: string;
}

export function ErrorScreen({
  code = 'ERROR',
  title = 'Something went wrong',
  description = 'An unexpected error occurred. You can try again, or reload the page.',
  onRetry,
  onReload,
  onHome,
  homeLabel = 'Go to dashboard',
}: ErrorScreenProps) {
  return (
    <div className="bg-bg flex min-h-screen w-full flex-1 items-center justify-center p-6">
      <EmptyState className="w-full max-w-lg bg-transparent">
        <span className="text-primary-9 flex h-12 w-12 items-center justify-center">
          <Icon symbol="error-warning-line" className="h-9 w-9" />
        </span>

        <EmptyState.Label>{code}</EmptyState.Label>
        <EmptyState.Title>{title}</EmptyState.Title>
        <EmptyState.Description>{description}</EmptyState.Description>

        {(onRetry || onReload || onHome) && (
          <EmptyState.Actions>
            {onRetry && (
              <Button variant="primary" icon="refresh-line" onClick={onRetry}>
                Try again
              </Button>
            )}
            {onReload && (
              <Button variant="secondary" icon="loop-right-line" onClick={onReload}>
                Reload page
              </Button>
            )}
            {onHome && (
              <Button variant="ghost" icon="dashboard-line" onClick={onHome}>
                {homeLabel}
              </Button>
            )}
          </EmptyState.Actions>
        )}
      </EmptyState>
    </div>
  );
}
